// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  restaurantId: __t.u64().name("restaurant_id"),
  guestId: __t.u64().name("guest_id"),
  clientTempId: __t.string().name("client_temp_id"),
  recipeId: __t.string().name("recipe_id"),
  state: __t.string(),
  stateClockMs: __t.i64().name("state_clock_ms"),
  baseCookSecondsMs: __t.i64().name("base_cook_seconds_ms"),
  cookSecondsMs: __t.i64().name("cook_seconds_ms"),
  appliance: __t.string(),
  assignedChefId: __t.string().name("assigned_chef_id"),
  seatX: __t.f32().name("seat_x"),
  seatZ: __t.f32().name("seat_z"),
  seatFloor: __t.u32().name("seat_floor"),
  seatAtBar: __t.bool().name("seat_at_bar"),
  pickupX: __t.f32().name("pickup_x"),
  pickupZ: __t.f32().name("pickup_z"),
  pickupFloor: __t.u32().name("pickup_floor"),
  createdAt: __t.timestamp().name("created_at"),
  stirred: __t.bool(),
});
